export enum Permissao {
    ADMINISTRAR_CONTAS  = 'ADMINISTRAR_CONTAS',
    EDITAR_CONTA_CAIXA  = 'EDITAR_CONTA_CAIXA',
    ARQUIVAR_CONTA_CAIXA   = 'ARQUIVAR_CONTA_CAIXA',
    DESARQUIVAR_CONTA_CAIXA = 'DESARQUIVAR_CONTA_CAIXA',
    EDITAR_OBSERVACAO_LANC_BANCO = 'EDITAR_OBSERVACAO_LANC_BANCO',
    EDITAR_LANCAMENTO_CAIXA = 'EDITAR_LANCAMENTO_CAIXA',
    TRAVAR_CONTA_CAIXA      = 'TRAVAR_CONTA_CAIXA',
    EXPORTAR_CONCILIACAO    = 'EXPORTAR_CONCILIACAO',
    IMPORTAR_EXTRATO        = 'IMPORTAR_EXTRATO',
    VISUALIZAR_RELATORIO_CAIXA = 'VISUALIZAR_RELATORIO_CAIXA',
    EDITAR_RELATORIO_CAIXA  = 'EDITAR_RELATORIO_CAIXA',
    VISUALIZAR_CONCILIACAO  = 'VISUALIZAR_CONCILIACAO',
    EDITAR_CONCILIACAO      = 'EDITAR_CONCILIACAO',
    VISUALIZAR_CONFIGURACAO_CAIXA = 'VISUALIZAR_CONFIGURACAO_CAIXA',
    EDITAR_TIPO_LANCAMENTO  = 'EDITAR_TIPO_LANCAMENTO',
    VISUALIZAR_MOVIMENTACAO_CAIXA = 'VISUALIZAR_MOVIMENTACAO_CAIXA',
    VISUALIZAR_REGRA_CONCILIACAO_AUTOMATICA = 'VISUALIZAR_REGRA_CONCILIACAO_AUTOMATICA',
    EDITAR_REGRA_CONCILIACAO_AUTOMATICA = 'EDITAR_REGRA_CONCILIACAO_AUTOMATICA',
    DESFAZER_IMPORTACAO_LANCAMENTOS_BANCO = 'DESFAZER_IMPORTACAO_LANCAMENTOS_BANCO',
    TROCAR_SENHA_USUARIO = 'TROCAR_SENHA_USUARIO',
    EDITAR_ROTEIRO_VISTORIA = 'EDITAR_ROTEIRO_VISTORIA',
    REALIZAR_VISTORIA = 'REALIZAR_VISTORIA',
    GERAR_RELATORIO_VISTORIA = 'GERAR_RELATORIO_VISTORIA',
    BAIXAR_FOTOS_VISTORIA = 'BAIXAR_FOTOS_VISTORIA',
    VISUALIZAR_PAINEL_FINANCEIRO = 'VISUALIZAR_PAINEL_FINANCEIRO',
}